import apiClient from '../../shared/services/apiClient';

/**
 * Admin CDN operator tools: IP banlist + WAF analytics.
 * Every method resolves to { success, ... } and never throws.
 */
const fail = (error) => ({
  success: false,
  error: error.response?.data?.error || error.response?.data?.message || error.message,
});

const get = async (url, params) => {
  try {
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    return fail(error);
  }
};

const cdnToolsService = {
  // ---------- IP banlist (/api/admin/cdn/banlist) ----------
  getBans: (params) => get('/api/admin/cdn/banlist', { device_type: 'ip', ...params }),

  async addBan({ ip, ttl_secs = 0, reason = '' }) {
    try {
      const response = await apiClient.post('/api/admin/cdn/banlist', { ip, ttl_secs, reason, scene: 'manual' });
      return response.data;
    } catch (error) {
      return fail(error);
    }
  },

  async removeBan(id) {
    try {
      const response = await apiClient.delete(`/api/admin/cdn/banlist/${id}`);
      return response.data;
    } catch (error) {
      return fail(error);
    }
  },

  // ---------- WAF analytics (/api/admin/waf-analytics/*) ----------
  getWafOverview: (params) => get('/api/admin/waf-analytics/overview', params),
  getWafTimeline: (params) => get('/api/admin/waf-analytics/timeline', params),
  getWafTopRules: (params) => get('/api/admin/waf-analytics/top-rules', params),
  getWafTopIPs: (params) => get('/api/admin/waf-analytics/top-ips', params),
  getWafLogs: (params) => get('/api/admin/waf-analytics/logs', params),
};

export default cdnToolsService;
